import PageMain from '../../components/Navigation/PageMain/PageMain';
import AiSettings from '../../components/Settings/Ai/AiSettings';

export default function AiSettingsPage() {
    return (
        <PageMain pageTitle="AI Settings" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <AiSettings />
                </div>
            </div>
        </PageMain>
    );
}
